import { Preferences } from '@capacitor/preferences';

const set = async (key, value) => {
  localStorage.setItem(key, value);

  await Preferences.set({
    key,
    value,
  });
};

const get = async (key) => {
  try {
    const result = await Preferences.get({ key });
    return result.value;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return null;
  }
};

const remove = async (key) => {
  try {
    await Preferences.remove({ key });
    localStorage.removeItem(key);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

export const appStorage = { set, get, remove };
